import { useEffect, useState } from 'react';
import { useModal } from '../../components/ModalProvider';
import { managerApi } from '../../lib/api';

export function PerfisTab() {
  const { showModal, closeModal } = useModal();
  const [profiles, setProfiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    managerApi.getProfiles().then((res) => setProfiles(res.profiles)).finally(() => setLoading(false));
  }, []);

  function viewImage(title: string, url: string | null, downloadName: string) {
    if (!url) {
      showModal(<><h2>{title}</h2><p className="hint">Este funcionário ainda não enviou este item.</p><button className="btn btn-ghost btn-block" onClick={closeModal}>Fechar</button></>);
      return;
    }
    showModal(<>
      <h2>{title}</h2>
      <div style={{ textAlign: 'center' }}><img src={url} style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 12 }} /></div>
      <a className="btn btn-primary btn-block" style={{ marginTop: 10, textDecoration: 'none' }} href={url} download={downloadName}>Baixar</a>
      <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Fechar</button>
    </>);
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <h2>Perfis, fotos, documentos e assinaturas</h2>
        <p className="hint">Área exclusiva do gestor com os dados de identificação de cada funcionário — assinatura cadastrada, foto de perfil, foto do documento oficial e status do termo de aceite. Tudo pode ser baixado a qualquer momento.</p>
      </div>
      {profiles.length === 0 && <p className="hint">Nenhum funcionário cadastrado.</p>}
      {profiles.map((p) => (
        <div className="card" style={{ display: 'flex', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' }} key={p.id}>
          <div style={{ flex: 'none' }}>
            {p.profilePhotoUrl
              ? <img src={p.profilePhotoUrl} style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: '50%', border: '2px solid var(--pink)' }} />
              : <div style={{ width: 70, height: 70, borderRadius: '50%', background: 'var(--surface-soft)', border: '1px solid var(--line)' }} />}
          </div>
          <div style={{ flex: 1, minWidth: 180 }}>
            <div style={{ fontWeight: 700 }}>{p.nome}</div>
            <div className="muted">{p.funcao} · {p.camarote}</div>
            <div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              <span className={`pill ${p.consentAceito ? 'pill-ok' : 'pill-pending'}`}>{p.consentAceito ? 'termo aceito' : 'termo pendente'}</span>
              <span className={`pill ${p.hasSignature ? 'pill-ok' : 'pill-pending'}`}>{p.hasSignature ? 'assinatura ok' : 'assinatura pendente'}</span>
              <span className={`pill ${p.profilePhotoUrl ? 'pill-ok' : 'pill-pending'}`}>{p.profilePhotoUrl ? 'foto ok' : 'foto pendente'}</span>
              <span className={`pill ${p.hasDocumentPhoto ? 'pill-ok' : 'pill-pending'}`}>{p.hasDocumentPhoto ? 'documento ok' : 'documento pendente'}</span>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <button className="btn btn-ghost btn-sm" onClick={() => viewImage(`Assinatura de ${p.nome}`, p.signatureUrl, `assinatura_${p.nome.replace(/\s+/g, '_')}.png`)}>Ver assinatura</button>
            <button className="btn btn-ghost btn-sm" onClick={() => viewImage(`Foto de ${p.nome}`, p.profilePhotoUrl, `foto_${p.nome.replace(/\s+/g, '_')}.jpg`)}>Ver foto</button>
            <button className="btn btn-ghost btn-sm" onClick={() => viewImage(`Documento de ${p.nome}`, p.documentPhotoUrl, `documento_${p.nome.replace(/\s+/g, '_')}.jpg`)}>Ver documento</button>
          </div>
        </div>
      ))}
    </>
  );
}
